import { LifecycleEvent } from "@ng-mw/shared-react-components"

export default {
    ...LifecycleEvent,
    GoToMyRecipesClicked: "lifecycle:go-to-my-recipes-clicked",
    GoToStoredRecipes: "lifecycle:go-to-stored-recipes-clicked",
    UpdateFavoriteRecipes: "lifecycle:update-favorite-recipes",
    RecipeTabClicked: "lifecycle:recipe-tab-clicked",
    DataUpdated: "lifecycle:data-updated",
}
